"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _List = _interopRequireDefault(require("./List"));
var _default = _List.default;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/rc-virtual-list/lib/index.js
// module id = 373
// module chunks = 0